import React, { Component } from "react";

function App(props) {
    const { data, i18n } = props;
    const { riasecModel, mappingObj } = i18n.report;

    const getTagTop = (value, total) => (total || 178) * (1 - value / 100) / 100 + "rem";

    return (
        <div className="riasec-mobile-wrap">
        	<p className="riasec-mobile-text">{riasecModel.infoText1}</p>
        	<p className="riasec-mobile-text">{riasecModel.infoText2}</p>
            <div className="riasec-mobile-table">
                <div className="riasec-mobile-table-tr">
                    <div className="riasec-mobile-title bgColor14">{mappingObj.stressReaction}</div>
                    <div className="riasec-mobile-item">
                        <div className="riasec-mobile-item-content">
                            <div className="riasec-mobile-item-label">{riasecModel.high}</div>
                            <div className="riasec-mobile-item-text">{riasecModel.stressReactionText3}</div>
                        </div>
                        <div className="riasec-mobile-item-content">
                            <div className="riasec-mobile-item-label">{riasecModel.med}</div>
                            <div className="riasec-mobile-item-text">{riasecModel.stressReactionText2}</div>
                        </div>
                        <div className="riasec-mobile-item-content">
                            <div className="riasec-mobile-item-label">{riasecModel.low}</div>
                            <div className="riasec-mobile-item-text">{riasecModel.stressReactionText1}</div>
                        </div>
                        <div className="riasec-mobile-arrow bgColor14 fontColor14">
                            <div>0</div>
                            <div>100</div>
                        </div>
                        <div className="riasec-mobile-tag bgColor14-opacity" style={{ top: getTagTop(data.stress_reaction.value) }}></div>
                        </div>
                </div>
                <div className="riasec-mobile-table-tr">
                    <div className="riasec-mobile-title bgColor15">{mappingObj.outgoing}</div>
                    <div className="riasec-mobile-item">
                        <div className="riasec-mobile-item-content">
                            <div className="riasec-mobile-item-label">{riasecModel.high}</div>
                            <div className="riasec-mobile-item-text">{riasecModel.outgoingText3}</div>
                        </div>
                        <div className="riasec-mobile-item-content">
                            <div className="riasec-mobile-item-label">{riasecModel.med}</div>
                            <div className="riasec-mobile-item-text">{riasecModel.outgoingText2}</div>
                        </div>
                        <div className="riasec-mobile-item-content">
                            <div className="riasec-mobile-item-label">{riasecModel.low}</div>
                            <div className="riasec-mobile-item-text">{riasecModel.outgoingText1}</div>
                        </div>
                        <div className="riasec-mobile-arrow bgColor15 fontColor15">
                            <div>0</div>
                            <div>100</div>
                        </div>
                        <div className="riasec-mobile-tag bgColor15-opacity" style={{ top: getTagTop(data.outgoing.value, 216) }}></div>
                        </div>
                </div>
                <div className="riasec-mobile-table-tr">
                    <div className="riasec-mobile-title bgColor16">{mappingObj.creativity}</div>
                    <div className="riasec-mobile-item">
                        <div className="riasec-mobile-item-content">
                            <div className="riasec-mobile-item-label">{riasecModel.high}</div>
                            <div className="riasec-mobile-item-text">{riasecModel.creativityText3}</div>
                        </div>
                        <div className="riasec-mobile-item-content">
                            <div className="riasec-mobile-item-label">{riasecModel.med}</div>
                            <div className="riasec-mobile-item-text">{riasecModel.creativityText2}</div>
                        </div>
                        <div className="riasec-mobile-item-content">
                            <div className="riasec-mobile-item-label">{riasecModel.low}</div>
                            <div className="riasec-mobile-item-text">{riasecModel.creativityText1}</div>
                        </div>
                        <div className="riasec-mobile-arrow bgColor16 fontColor16">
                            <div>0</div>
                            <div>100</div>
                        </div>
                        <div className="riasec-mobile-tag bgColor16-opacity" style={{ top: getTagTop(data.creativity.value, 216) }}></div>
                        </div>
                </div>
                <div className="riasec-mobile-table-tr">
                    <div className="riasec-mobile-title bgColor17">{mappingObj.agreeableness}</div>
                    <div className="riasec-mobile-item">
                        <div className="riasec-mobile-item-content">
                            <div className="riasec-mobile-item-label">{riasecModel.high}</div>
                            <div className="riasec-mobile-item-text">{riasecModel.agreeablenessText3}</div>
                        </div>
                        <div className="riasec-mobile-item-content">
                            <div className="riasec-mobile-item-label">{riasecModel.med}</div>
                            <div className="riasec-mobile-item-text">{riasecModel.agreeablenessText2}</div>
                        </div>
                        <div className="riasec-mobile-item-content">
                            <div className="riasec-mobile-item-label">{riasecModel.low}</div>
                            <div className="riasec-mobile-item-text">{riasecModel.agreeablenessText1}</div>
                        </div>
                        <div className="riasec-mobile-arrow bgColor17 fontColor17">
                            <div>0</div>
                            <div>100</div>
                        </div>
                        <div className="riasec-mobile-tag bgColor17-opacity" style={{ top: getTagTop(data.agreeableness.value) }}></div>
                        </div>
                </div>
                <div className="riasec-mobile-table-tr">
                    <div className="riasec-mobile-title bgColor18">{mappingObj.conscientiousness}</div>
                    <div className="riasec-mobile-item">
                        <div className="riasec-mobile-item-content">
                            <div className="riasec-mobile-item-label">{riasecModel.high}</div>
                            <div className="riasec-mobile-item-text">{riasecModel.conscientiousnessText3}</div>
                        </div>
                        <div className="riasec-mobile-item-content">
                            <div className="riasec-mobile-item-label">{riasecModel.med}</div>
                            <div className="riasec-mobile-item-text">{riasecModel.conscientiousnessText2}</div>
                        </div>
                        <div className="riasec-mobile-item-content">
                            <div className="riasec-mobile-item-label">{riasecModel.low}</div>
                            <div className="riasec-mobile-item-text">{riasecModel.conscientiousnessText1}</div>
                        </div>
                        <div className="riasec-mobile-arrow bgColor18 fontColor18">
                            <div>0</div>
                            <div>100</div>
                        </div>
                        <div className="riasec-mobile-tag bgColor18-opacity" style={{ top: getTagTop(data.conscientiousness.value, 197) }}></div>
                        </div>
                </div>
        	</div>
        </div>
    );
}

export default App;
